class ProductTile extends HTMLElement {
  select;
  buttons;
  quantity;

  constructor() {
    super();
  }

  connectedCallback() {
    this.select = this.querySelector(".tile-variants");
    if (this.select) {
      this.select.addEventListener("change", this.onTileVariantSelectChange.bind(this));
      const liveRegion = this.querySelector('[data-live-region="variant"]');
      if (liveRegion) {
        this._initialTilePriceHtml = liveRegion.innerHTML;
      }
    }

    this.quantity = this.querySelector("[name='quantity']");

    this.buttons = this.querySelectorAll(".tile-variant-add");
    this.buttons.forEach((element) => {
      element.addEventListener("click", this.onTileAddToCartClick.bind(this));
    });

    if (this.select) {
      this.onTileVariantSelectChange();
    }
  }

  /**
   * Determine & add the correct variant to the cart
   * 
   * @param {Event} e The click event 
   */
   onTileAddToCartClick(e) {
    const button = e.currentTarget;

    // Determine the variant ID to add
    var variantId = button.dataset.tileVariantId;
    if(variantId === undefined){
      variantId = this.select.value;
    }

    // Invalid variant id - add error class to form input
    if(variantId === ""){
      setTimeout(function(){
        this.select.classList.add("is-invalid");
      }.bind(this), 10);
      return;
    }

    // Set visual state of button
    button.classList.add('loading');
    button.querySelector(".spinner-overlay").classList.remove('d-none');

    let properties = {};
    if(button.dataset.tileVariantProperties){
      let propertiesArray = JSON.parse(atob(button.dataset.tileVariantProperties));
      propertiesArray.forEach(e => {
        let propertyParts = e.split("||||");
        properties[propertyParts[0]] = propertyParts[1];
      });
    }

    // Add the selected variant to the cart. Delay slightly so it feels like
    // something is happening (otherwise it's basically instant!)
    const quantityInput = this.resolveQuantityInput(button);

    MP.Extensions.Cart.add([{
      id: variantId,
      quantity: parseInt(quantityInput?.value, 10) || 1,
      properties
    }]).then(() => { setTimeout(this.onVariantAddedToCart(), 1500); });
  }

  resolveQuantityInput(button) {
    const scopedQuantity = button.closest('[data-tile-actions]')?.querySelector("[name='quantity']");
    if (scopedQuantity) return scopedQuantity;
    return this.querySelector("[name='quantity']");
  }

  onVariantAddedToCart() {
    // Reset visual state of button, if there's only 1
    this.buttons.forEach(element => {
      element.classList.remove('loading');
      element.querySelector(".spinner-overlay").classList.add('d-none');
    });
  }

  onTileVariantSelectChange() {
    this.select.classList.remove('is-invalid');

    const selected = this.select.options[this.select.selectedIndex];
    if (!selected || !selected.value) {
      if (this._initialTilePriceHtml !== undefined) {
        const liveRegion = this.querySelector('[data-live-region="variant"]');
        if (liveRegion) {
          liveRegion.innerHTML = this._initialTilePriceHtml;
        }
      }
      return;
    }

    const price = selected.dataset.price;
    const compareAt = selected.dataset.compareAtPrice;
    const onSale = Boolean(compareAt);
    const sku = selected.dataset.sku;
    const isAvailable = selected.dataset.available !== 'false';

    // Query the whole tile so multiple data-live-region="variant" blocks
    // (e.g. SKU + price) can all update from one select change.
    const compareSpan = this.querySelector("[data-mp-compare-price]");
    const priceSpan = this.querySelector(".product-price");
    const compareStrike = compareSpan?.querySelector("s");
    const skuSpan = this.querySelector("[data-mp-sku]");

    if (priceSpan && price) {
      priceSpan.textContent = price;
      priceSpan.classList.toggle("text-danger", onSale);
    }

    if (compareSpan && compareStrike) {
      compareSpan.classList.toggle("d-none", !onSale);
      if (onSale) {
        compareStrike.textContent = compareAt;
      }
    }

    if (skuSpan && sku !== undefined) {
      skuSpan.textContent = sku;
    }

    this.querySelectorAll('[data-show-when-oos]').forEach((element) => {
      element.classList.toggle('d-none', isAvailable);
    });
    this.querySelectorAll('[data-hide-when-oos]').forEach((element) => {
      element.classList.toggle('d-none', !isAvailable);
    });

  }
}

export default ProductTile;